import { render, staticRenderFns } from "./LocaleStringDetail.vue?vue&type=template&id=769e9d5b&scoped=true&"
import script from "./LocaleStringDetail.vue?vue&type=script&lang=js&"
export * from "./LocaleStringDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e9d5b",
  null
  
)

export default component.exports